import { useQuery } from '@apollo/client';
import { useRouter } from 'next/router';

import GetCourseMetricDetailQuery from '../graphql/GetCourseMetricDetail.graphql';
import type {
  GetCourseMetricDetail,
  GetCourseMetricDetailVariables,
} from '../graphql/types/GetCourseMetricDetail';

const useCourseDetail = () => {
  const router = useRouter();
  const { originalId } = router.query as { originalId: string };

  const { data, loading } = useQuery<
    GetCourseMetricDetail,
    GetCourseMetricDetailVariables
  >(GetCourseMetricDetailQuery, {
    context: { clientName: 'v2' },
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first',
    variables: {
      id: originalId,
    },
  });

  return { course: data?.course, isLoading: loading };
};

export default useCourseDetail;
